module.exports = __webpack_public_path__ + "img/other.68915d70.svg";